export const accessKeys = {
    getTotalNewsCount: "getTotalNewsCount",
    getTotalShareCount: "getTotalShareCount",
    getTotalLikeCount: "getTotalLikeCount",
    getTotalViewsCount: "getTotalViewsCount",
    getTotalUserCount: "getTotalUserCount",
    getAllPollCount: "getAllPollCount",
    updateUser: "updateUser",
    updateUserStatus: "updateUserStatus",
    getUserList: "getUserList",
    updateAdminStatus: "updateAdminStatus",
    getAdminList: "getAdminList",
    updateAdmin: "updateAdmin",
    addAdmin: "addAdmin",
    setPollOrder: "setPollOrder",
    updateDateInPoll: "updateDateInPoll",
    updateVotingStatusInPoll: "updateVotingStatusInPoll",
    updatePoll: "updatePoll",
    addPoll: "addPoll",
    getAllPoll: "getAllPoll",
    updateCategoryStatus: "updateCategoryStatus",
    updateCategoryIsPrimary: "updateCategoryIsPrimary",
    getAllCategoryList: "getAllCategoryList",
    updateCategory: "updateCategory",
    addNewCategory: "addNewCategory",
    updateStatusInLanguage: "updateStatusInLanguage",
    updateInAppStatusInLanguage: "updateInAppStatusInLanguage",
    updateLanguage: "updateLanguage",
    getAllLanguage: "getAllLanguage",
    addLanguage: "addLanguage",
    updateNotificationTopicsStatus: "updateNotificationTopicsStatus",
    updateNotificationTopics: "updateNotificationTopics",
    getAllNotificationTopics: "getAllNotificationTopics",
    addNotificationTopics: "addNotificationTopics",
    updateHomePageOrder: "updateHomePageOrder",
    addHomePageData: "addHomePageData",
    updateHomePageData: "updateHomePageData",
    homePageDataList: "homePageDataList",
    updateHomePageStatus: "updateHomePageStatus",
    getAllNews: "getAllNews",
    addNews: "addNews",
    updateNews: "updateNews",
    updateNewsStatus: "updateNewsStatus",
    sendNewsNotificationToUSer: "sendNewsNotificationToUSer",
    addCardType: "addCardType",
    getCardTypeList: "getCardTypeList",
    updateCardType: "updateCardType",
    updateCardTypeStatus: "updateCardTypeStatus",
    addListType: "addListType",
    getListTypeList: "getListTypeList",
    updateListType: "updateListType",
    updateListTypeStatus: "updateListTypeStatus",
    getAdminAccess: "getAdminAccess",
    getAllAccessList: "getAllAccessList",
    updateAdminAccess: "updateAdminAccess",

    getUpcomingMatch: "getUpcomingMatch",
    getLiveMatch: "getLiveMatch",
    getCompletedMatch: "getCompletedMatch",
    updateMatchShowStatus: "updateMatchShowStatus",
    updateMatchOrder: "updateMatchOrder",
}